import { useEffect, useEffectEvent } from 'react';
import { useIsMobile } from '@/hooks/useIsMobile';

export const useCloseOnBreakpointChange = (
  isOpen: boolean,
  onClose: () => void,
) => {
  const isMobile = useIsMobile();

  const closeIfOpen = useEffectEvent(() => {
    if (isOpen) {
      onClose();
    }
  });

  useEffect(() => {
    closeIfOpen();
  }, [isMobile]);
};
